<footer class="footer">
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-6">
        
      </div>
      <div class="col-sm-6">
        <div class="text-sm-right d-none d-sm-block">
          <!-- Designed <i class="mdi mdi-heart text-danger"></i> -->
        </div>
      </div>
    </div>
  </div>
</footer>
